let url = ''
if(process.env.NODE_ENV === "development"){
    url = "http://wyl/ScavcYX/WebAPI/"
}else if(process.env.NODE_ENV === "production"){
    url = "/WebApi/"
}
export default url


// WEBPACK FOOTER //
// ./src/assets/js/baseUrl.js